import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Monitor, Smartphone, AlertCircle } from "lucide-react";

export const MobileNotSupported = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <div className="w-full max-w-2xl">
        <Card className="
          bg-background/95
          backdrop-blur-lg
          border border-border/30
          shadow-[0_3px_16px_rgba(0,0,0,0.04),0_1px_6px_rgba(0,0,0,0.02)]
          hover:shadow-[0_6px_24px_rgba(0,0,0,0.06),0_2px_10px_rgba(0,0,0,0.03)]
          rounded-3xl
          transition-all duration-500 ease-out
        ">
          <CardHeader className="pb-6 pt-8 px-8">
            <div className="flex items-center gap-4 mb-4">
              <div className="text-primary/80 p-4 rounded-2xl bg-primary/10 border border-primary/20 shadow-[0_1px_3px_rgba(0,0,0,0.1)]">
                <AlertCircle className="h-6 w-6" />
              </div>
              <CardTitle className="text-3xl font-bold text-foreground tracking-tight">
                Mobile Not Supported
              </CardTitle>
            </div>
          </CardHeader>
          <CardContent className="px-8 pb-8">
            <div className="space-y-6">
              <p className="text-lg text-muted-foreground font-medium leading-relaxed">
                Currently, the dashboard is only available on desktop computers and laptops. 
                We're working on mobile optimization and will notify you when it's ready.
              </p>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">
                <div className="flex items-start gap-4 p-6 rounded-3xl bg-gradient-to-br from-muted/30 to-muted/10 backdrop-blur-md border border-border/20 shadow-[0_2px_8px_rgba(0,0,0,0.02)]">
                  <div className="text-primary/80 p-3 rounded-2xl bg-primary/10 border border-primary/20 shadow-[0_1px_3px_rgba(0,0,0,0.1)]">
                    <Monitor className="h-5 w-5" />
                  </div>
                  <div>
                    <h3 className="text-base font-bold text-foreground mb-1">Desktop Access</h3>
                    <p className="text-sm text-muted-foreground font-medium">
                      Please access the dashboard from a desktop computer or laptop for the best experience.
                    </p>
                  </div>
                </div>
                
                <div className="flex items-start gap-4 p-6 rounded-3xl bg-gradient-to-br from-muted/30 to-muted/10 backdrop-blur-md border border-border/20 shadow-[0_2px_8px_rgba(0,0,0,0.02)] opacity-60">
                  <div className="text-muted-foreground/80 p-3 rounded-2xl bg-muted/20 border border-border/20">
                    <Smartphone className="h-5 w-5" />
                  </div>
                  <div>
                    <h3 className="text-base font-bold text-foreground mb-1">Mobile Coming Soon</h3>
                    <p className="text-sm text-muted-foreground font-medium">
                      Mobile support is in development and will be available soon.
                    </p>
                  </div>
                </div>
              </div>
              
              <div className="mt-8 p-6 rounded-3xl bg-primary/5 border border-primary/20">
                <p className="text-sm text-muted-foreground font-medium text-center">
                  <span className="font-semibold text-foreground">Note:</span> The onboarding process is available on mobile devices. 
                  After completing onboarding, please access your dashboard from a desktop computer.
                </p>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};


